/*
    Swiper JS functions:
    1. slidesPerView: Number of slides visible at a time.
    2. spaceBetween: Gap between each slide.
    3. loop: Enables infinite scrolling of slides.
    4. breakpoints: Define different settings for various viewport widths.
    5. navigation: Enable previous and next buttons.
    6. pagination: Adds a pagination element (dots) for navigation.
    7. autoplay: Automatically transition slides after a delay.
    8. effect: Apply different slide effects such as fade, cube, flip, etc.
    9. grabCursor: Changes the cursor to a "grab" icon on hover.
    10. keyboard: Enable keyboard navigation for slides.
    11. mousewheel: Enable mouse wheel interaction for scrolling.
    12. scrollbar: Add a draggable scrollbar for navigation.
    13. on: Define event listeners like `init`, `slideChange`, `reachEnd`, etc.

    new Swiper('.swiper', {
        pagination: {
            el: '.swiper-pagination', // Class for pagination
            clickable: true, // Pagination dots are clickable
        },
        autoplay: {
            delay: 5000, // Auto-slide every 5 seconds
            disableOnInteraction: false, // Continue autoplay after interaction
        },
        effect: 'fade', // Slide transition effect (e.g., 'slide', 'fade', 'cube', 'coverflow', 'flip')
        grabCursor: true, // Show grab cursor on hover
        keyboard: {
            enabled: true, // Allow keyboard navigation
            onlyInViewport: true, // Only enable in the viewport
        },
        mousewheel: {
            invert: false, // Invert mousewheel scroll direction
        },
        scrollbar: {
            el: '.swiper-scrollbar', // Class for scrollbar
            draggable: true, // Allow dragging the scrollbar
        },
        on: {
            // Events example
            init: function () {
                console.log('Swiper initialized');
            },
            slideChange: function () {
                console.log('Slide changed to index:', this.activeIndex);
            },
            reachEnd: function () {
                console.log('Reached the end of slides');
            },
            autoplayStart: function () {
                console.log('Autoplay started');
            },
            autoplayStop: function () {
                console.log('Autoplay stopped');
            },
        }
    }
*/

var $ = jQuery;
$(document).ready(function ($) {
    // Hero Banner
    if($('.bnr-hero').length > 0){
        new Swiper('.bnr-hero .swiper', {
            loop: false,
            slidesPerView: 1,
            navigation: {
                nextEl: ".bnr-hero .swiper-button-next",
                prevEl: ".bnr-hero .swiper-button-prev",
            },
            pagination: {
                el: ".bnr-hero .swiper-pagination",
                clickable: true,
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }


    // Testimonial Block
    if($('.blk-testimonial').length > 0){
        $('.blk-testimonial').each(function(){
            const numSlider = $(this).attr('data-num');
            const swiperContainer = $(this).find('.swiper');
            const nextButton = $(this).find('.swiper-button-next');
            const prevButton = $(this).find('.swiper-button-prev');


            new Swiper(swiperContainer[0], {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 16,
                breakpoints: {
                    1024: {
                        slidesPerView: parseInt(numSlider, 10),
                        spaceBetween: 24,
                    },
                    768: {
                        slidesPerView: parseInt(numSlider, 10) > 1 ? 2 : 1,
                        spaceBetween: 16,
                    },
                },
                navigation: {
                    nextEl: nextButton[0],
                    prevEl: prevButton[0],
                },
                allowTouchMove: true,
                keyboard: {
                    enabled: true,
                },
            });
        }) 
    }

    // Similar Block in Article page
    if($('.blk-similar-articles').length > 0){
        new Swiper('.blk-similar-articles .swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
            },
            navigation: {
                nextEl: ".blk-similar-articles .swiper-button-next",
                prevEl: ".blk-similar-articles .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }

    // News Carousel Block
    if($('.blk-news-carousel').length > 0){
        new Swiper('.blk-news-carousel .swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                },
            },
            navigation: {
                nextEl: ".blk-news-carousel .swiper-button-next",
                prevEl: ".blk-news-carousel .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }


    setTimeout(function() {
        matchHeight();
    }, 500); 
});


$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});

// Function to equalize the height of elements within a container
function matchHeight() {
    // Check if there are any elements with the class 'match-height-wrapper'
    if ($(".match-height-wrapper").length > 0) {
        // Iterate over each 'match-height-wrapper' container
        $(".match-height-wrapper").each(function() {
            // Find all elements with the class 'match-height' inside the current wrapper
            const elements = $(this).find('.match-height');

            // Initialize a variable to track the maximum height
            let maxHeight = 0;

            // Iterate over each 'match-height' element to determine the tallest one
            elements.each(function() {
                // Get the current element's height, including padding, border, and margin
                const currentHeight = $(this).outerHeight();

                // Update maxHeight if the current element's height is greater
                if (currentHeight > maxHeight) {
                    maxHeight = currentHeight;
                }
            });

            // Set all 'match-height' elements to the tallest height
            elements.height(maxHeight);
        });
    }
}
